// Common component styles
export const theme = {
  container: 'max-w-7xl mx-auto px-container',
  section: 'py-section',
  
  text: {
    display: 'text-display font-heading font-bold text-[#0C3B2E]',
    h1: 'text-h1 font-heading font-bold text-[#0C3B2E]',
    h2: 'text-h2 font-heading font-semibold text-[#0C3B2E]',
    h3: 'text-h3 font-heading font-semibold text-[#0C3B2E]',
    body: 'text-body text-text-primary',
    small: 'text-sm text-text-secondary',
  },

  button: {
    base: 'rounded-lg font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2',
    primary: 'bg-[#6D9773] hover:bg-[#0C3B2E] text-white focus:ring-[#6D9773]',
    secondary: 'border border-[#6D9773] text-[#6D9773] hover:bg-[#0C3B2E] hover:text-white hover:border-[#0C3B2E]',
    cta: 'bg-[#FFBA00] hover:bg-[#E69500] text-white focus:ring-[#FFBA00]',
    outline: 'border-2 border-[#6D9773] text-[#6D9773] hover:bg-[#0C3B2E] hover:text-white hover:border-[#0C3B2E]',
    sizes: {
      sm: 'px-4 py-2 text-sm',
      md: 'px-6 py-3',
      lg: 'px-8 py-4 text-lg',
    }
  },

  card: {
    base: 'bg-white border border-[#6D9773]/20 rounded-lg shadow-sm p-6 text-[#0C3B2E]',
    hover: 'hover:shadow-lg transition-shadow duration-200',
    interactive: 'cursor-pointer hover:shadow-lg transition-shadow duration-200',
  },

  input: {
    base: 'w-full rounded-lg border-[#6D9773] shadow-sm focus:border-[#6D9773] focus:ring-[#6D9773]',
    error: 'border-red-500 focus:border-red-500 focus:ring-red-500',
    success: 'border-green-500 focus:border-green-500 focus:ring-green-500',
  },

  nav: {
    link: 'px-4 py-2 font-medium hover:text-[#0C3B2E] transition-colors duration-200',
    button: {
      base: 'px-4 py-2 rounded-lg font-medium transition-all duration-200',
      primary: 'bg-[#6D9773] hover:bg-[#0C3B2E] text-white shadow-sm hover:shadow',
      secondary: 'border border-[#6D9773] text-[#6D9773] hover:bg-[#0C3B2E] hover:text-white hover:border-[#0C3B2E]',
      active: 'text-[#0C3B2E]',
    }
  },

  page: {
    default: 'min-h-screen bg-white',
    dark: 'min-h-screen bg-[#0C3B2E] text-white',
  }
}